// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageEditor_root__3Sy7y"};